(function () {
  function initialiseHero(hero) {
    if (!hero || hero.dataset.heroInitialised === 'true') return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hoh-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hoh-hero-dot]'));
    var previous = hero.querySelector('[data-hoh-hero-previous]');
    var next = hero.querySelector('[data-hoh-hero-next]');
    var toggle = hero.querySelector('[data-hoh-hero-toggle]');
    var toggleLabel = hero.querySelector('[data-hoh-hero-toggle-label]');
    var currentIndex = 0;
    var timer = null;
    var pointerStart = null;
    var userPaused = false;
    var autoplay = hero.dataset.autoplay === 'true';
    var interval = parseInt(hero.dataset.interval, 10) || 7000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (slides.length < 2) return;

    function showSlide(index, userInitiated) {
      currentIndex = (index + slides.length) % slides.length;

      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.inert = !active;
      });

      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
        dot.setAttribute('tabindex', active ? '0' : '-1');
      });

      if (userInitiated) restartAutoplay();
    }

    function stopAutoplay() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (
        !autoplay ||
        reduceMotion ||
        userPaused ||
        document.hidden ||
        timer ||
        hero.matches(':hover') ||
        hero.contains(document.activeElement)
      ) return;
      timer = window.setInterval(function () {
        showSlide(currentIndex + 1, false);
      }, interval);
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    function updateToggle() {
      if (!toggle) return;
      toggle.hidden = !autoplay || reduceMotion;
      toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', userPaused ? 'Resume slideshow' : 'Pause slideshow');
      if (toggleLabel) toggleLabel.textContent = userPaused ? 'Play' : 'Pause';
    }

    if (previous) previous.addEventListener('click', function () { showSlide(currentIndex - 1, true); });
    if (next) next.addEventListener('click', function () { showSlide(currentIndex + 1, true); });

    dots.forEach(function (dot, dotIndex) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-hoh-hero-dot'), 10), true);
      });

      dot.addEventListener('keydown', function (event) {
        var targetIndex = dotIndex;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') targetIndex = (dotIndex + 1) % dots.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') targetIndex = (dotIndex - 1 + dots.length) % dots.length;
        if (event.key === 'Home') targetIndex = 0;
        if (event.key === 'End') targetIndex = dots.length - 1;
        if (targetIndex === dotIndex) return;
        event.preventDefault();
        showSlide(targetIndex, true);
        dots[targetIndex].focus();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) stopAutoplay();
        else startAutoplay();
        updateToggle();
      });
    }

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);
    hero.addEventListener('focusin', stopAutoplay);
    hero.addEventListener('focusout', startAutoplay);

    hero.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      pointerStart = event.clientX;
    });

    hero.addEventListener('pointerup', function (event) {
      if (pointerStart === null) return;
      var movement = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(movement) < 50) return;
      showSlide(currentIndex + (movement < 0 ? 1 : -1), true);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    hero._hohShowSlide = showSlide;
    hero.dataset.heroInitialised = 'true';
    updateToggle();
    showSlide(0, false);
    startAutoplay();
  }

  function initialiseAll(scope) {
    var root = scope || document;
    var heroes = root.matches && root.matches('[data-hoh-hero]')
      ? [root]
      : root.querySelectorAll('[data-hoh-hero]');
    Array.prototype.forEach.call(heroes, initialiseHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest && event.target.closest('[data-hoh-hero-slide]');
    if (!slide) return;
    var hero = slide.closest('[data-hoh-hero]');
    if (hero && hero._hohShowSlide) hero._hohShowSlide(parseInt(slide.dataset.slideIndex, 10), true);
  });
})();